import React, { useEffect } from "react";

const GoogleAd = ({
  slot = "7230548984",
  client = "ca-pub-9832341250704872",
  format = "auto",
  responsive = "true",
  remainingPrompts,
}) => {
  useEffect(() => {
    if (process.env.NODE_ENV === "production" && remainingPrompts === 0) {
      if (!window.adsbygoogle) {
        const script = document.createElement("script");
        script.async = true;
        script.src = `https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=${client}`;
        script.crossOrigin = "anonymous";
        script.onerror = () => {
          console.error(
            "AdSense script could not load. Check if ads are allowed on this domain."
          );
        };
        document.head.appendChild(script);
      }

      try {
        (window.adsbygoogle = window.adsbygoogle || []).push({});
      } catch (e) {
        console.error("AdSense error:", e);
      }
    }
    // eslint-disable-next-line
  }, [client, slot]);

  return (
    <ins
      className="adsbygoogle"
      style={{
        display: "block",
        width: "100%", // Full width within the container
        height: "150px", // Set a maximum height
        maxWidth: "100%",
        maxHeight: "200px",
        overflow: "hidden",
      }}
      data-ad-client={client}
      data-ad-slot={slot}
      data-ad-format={format}
      data-full-width-responsive={responsive}
    />
  );
};

export default GoogleAd;
